import React from "react";

/**
 * Renders a QR code image using a public QR API (no key required).
 * data: string to encode (URL).
 */
export const QRCodeImage = ({ data, size = 240, className = "" }) => {
  const url = `https://api.qrserver.com/v1/create-qr-code/?size=${size}x${size}&data=${encodeURIComponent(
    data
  )}&color=1c1c1c&bgcolor=fffbf5&qzone=2&margin=10`;
  return <img src={url} alt="QR code" width={size} height={size} className={className} data-testid="qr-image" />;
};

export const downloadQR = async (data, filename = "zaykaqr.png") => {
  const url = `https://api.qrserver.com/v1/create-qr-code/?size=600x600&data=${encodeURIComponent(
    data
  )}&color=1c1c1c&bgcolor=fffbf5&qzone=2&margin=12`;
  const res = await fetch(url);
  const blob = await res.blob();
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
};
